import { Controller } from "@hotwired/stimulus"
import { install, uninstall } from "@github/hotkey"

export default class extends Controller {
  connect() {
    this.installHotkeys()
  }

  disconnect() {
    this.uninstallHotkeys()
  }

  /**
   * Install hotkeys for all elements with data-hotkey attribute within this
   * controller's element
   */
  installHotkeys() {
    const hotkeyElements = this.element.querySelectorAll('[data-hotkey]')

    hotkeyElements.forEach(element => {
      install(element)
    })
  }

  /**
   * Uninstall hotkeys for all elements with data-hotkey attribute within this
   * controller's element
   */
  uninstallHotkeys() {
    const hotkeyElements = this.element.querySelectorAll('[data-hotkey]')

    hotkeyElements.forEach(element => {
      uninstall(element)
    })
  }
}
